import styled from 'styled-components'
import { IStyleElement } from '~/types/types'
import breakpoints from './breakpoints'

interface Props extends IStyleElement {
  centered?: boolean
  lineHeight?: number | string
  size?: number
  bold?: boolean | string
  color?: string
  align?: string
  padding?: string
  margin?: string
  mdSize?: number
  xlSize?: number
  lgSize?: number
  smSize?: number
  opacity?: number
}

const Text = styled.p<Props>`
  opacity: ${p => p.opacity || 1};
  margin-bottom: 0;
  text-align: ${p => p.centered ? 'center' : (p.align || 'left')};
  line-height: ${props => props.lineHeight || 1.5};
  font-size: ${props => props.size || 16}px;
  font-weight: ${props => props.bold === true ? 'bold' : (props.bold || 'normal')};
  color: ${props => props.color || '#172B4D'};
  padding: ${p => p.padding || ''};
  margin: ${p => p.margin || ''};
  transition: 250ms;
  ${p => p.xsStyle}
  ${breakpoints.sm} {
    ${p => p.smSize ? `font-size: ${p.smSize}px` : ''};
    ${p => p.smStyle}
  }
  ${breakpoints.md} {
    ${p => p.mdSize ? `font-size: ${p.mdSize}px` : ''};
    ${p => p.mdStyle}
  }
  ${breakpoints.lg} {
    ${p => p.lgSize ? `font-size: ${p.lgSize}px` : ''};
    ${p => p.lgStyle}
  }
  ${breakpoints.xl} {
    ${p => p.xlSize ? `font-size: ${p.xlSize}px` : ''};
    ${p => p.xlStyle}
  }
`
export default Text